export default __webpack_public_path__ + "static/media/hero.3c1177cd.svg";